/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedOneDWaterLevelFile
 */
export interface PatchedOneDWaterLevelFile {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  initialWaterlevel?: string;
  /**
   *
   */
  readonly initialWaterlevelId?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PatchedOneDWaterLevelFile interface.
 */
export function instanceOfPatchedOneDWaterLevelFile(
  value: object
): value is PatchedOneDWaterLevelFile {
  return true;
}

export function PatchedOneDWaterLevelFileFromJSON(json: any): PatchedOneDWaterLevelFile {
  return PatchedOneDWaterLevelFileFromJSONTyped(json, false);
}

export function PatchedOneDWaterLevelFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedOneDWaterLevelFile {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    initialWaterlevel: json["initial_waterlevel"] == null ? undefined : json["initial_waterlevel"],
    initialWaterlevelId:
      json["initial_waterlevel_id"] == null ? undefined : json["initial_waterlevel_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PatchedOneDWaterLevelFileToJSON(json: any): PatchedOneDWaterLevelFile {
  return PatchedOneDWaterLevelFileToJSONTyped(json, false);
}

export function PatchedOneDWaterLevelFileToJSONTyped(
  value?: Omit<
    PatchedOneDWaterLevelFile,
    "url" | "simulation" | "initialWaterlevelId" | "uid" | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    initial_waterlevel: value["initialWaterlevel"],
  };
}
